import { render, staticRenderFns } from "./BeneficiaryAddStepFour.vue?vue&type=template&id=8b945b54&scoped=true&"
import script from "./BeneficiaryAddStepFour.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAddStepFour.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryAddStepFour.vue?vue&type=style&index=0&id=8b945b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b945b54",
  null
  
)

export default component.exports